<!-- <li class="panel"> -->
    <ng-template [ngIf]="entity">
        <div class="controparte">
                <p class="col-sm-2">
                    <button (click)="emitEntity(entity)" class="btn btn-primary associa"
                        type="submit">Allega</button>
                </p>
                <p class=" col-sm-4" *ngIf="entity.esito" style="padding-left:15px;">
                    Provvedimento N. <strong>&nbsp;{{entity.esito.numeroEsito}}</strong>
                </p>
                <p class=" col-sm-4" *ngIf="entity.esito">
                      <strong>{{entity.esito.tipoEsito.descrizione}}</strong>
                </p>
                <p class=" col-sm-3" *ngIf="entity.tipoSomma">
                    <strong>{{entity.tipoSomma.descrizione}}</strong>
              </p>
        </div>
        </ng-template>
        <!-- </li> -->